// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
// theme
import {hideScroll} from 'packages/common/theme/css';
import {ADMIN_PALETTE} from 'packages/common/theme/admin';
// components
import {NavSectionMini} from 'packages/common/components/nav-section';
//
import {NAV} from '../config-layout';
import {useNavData} from './config-navigation';
import {NavToggleButton} from '../_common-admin';
import NavAccountSection from './nav-account-section';

// ----------------------------------------------------------------------

export default function NavMini() {
  const navData = useNavData();

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: {lg: 0},
        width: {lg: NAV.W_MINI},
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_MINI,
          bgcolor: ADMIN_PALETTE.nav.background,
          borderRight: `1px solid ${ADMIN_PALETTE.nav.border}`,
          display: 'flex',
          flexDirection: 'column',
          ...hideScroll.x,
        }}
      >
        <Box
          component="img"
          src="/logo/logo_white.svg"
          sx={{
            width: 40,
            height: 40,
            mx: 'auto',
            my: 2,
          }}
        />

        <NavSectionMini
          data={navData}
          sx={{
            '& .MuiListItemButton-root': {
              'color': ADMIN_PALETTE.text.primaryMuted,
              '&:hover': {
                bgcolor: ADMIN_PALETTE.interactive.hoverMedium,
                color: ADMIN_PALETTE.text.primary,
              },
            },
            '& .MuiListItemButton-root.active': {
              'bgcolor': ADMIN_PALETTE.accent.bg15,
              'color': ADMIN_PALETTE.accent.light,
              '&:hover': {
                bgcolor: ADMIN_PALETTE.accent.bg20,
              },
            },
            '& .MuiListItemIcon-root': {
              color: 'inherit',
            },
          }}
        />

        <Box sx={{flexGrow: 1}} />

        <NavAccountSection isMini />
      </Stack>
    </Box>
  );
}
